<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">教場編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'school-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_school.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">教場ID</th>
                <td />
                <td>{{ currentSchool.uid }}</td>
              </tr>

              <TextField v-model="currentSchool.name" extraRules="required" label="教場名" />
              <TextField
                v-model="currentSchool.nameReading"
                extraRules="required"
                label="教場名（フリガナ）"
                placeholder="全角カタカナ"
              />
              <PostalCodeField
                v-model="currentSchool.postalCode"
                @fillAddresses="fillAddresses($event)"
                extraRules="required"
                inputClass="col-lg-4"
              />
              <TextField
                v-model="currentSchool.state"
                extraRules="required"
                label="都道府県 市区町村"
                placeholder="例）京都府京都市中京区笋町"
              />
              <TextField
                v-model="currentSchool.address"
                extraRules="required"
                label="番地・建物名"
                placeholder="例）688 第15長谷ビル5F"
              />
              <TextField
                v-model="currentSchool.phone"
                extraRules="phone_number|required"
                label="電話番号"
                placeholder="例）075-708-8100"
              />
              <TextField
                v-model="currentSchool.fax"
                extraRules="phone_number"
                label="FAX番号"
                placeholder="例）075-708-8101"
              />
              <TextField
                v-model="currentSchool.email"
                extraRules="email"
                label="メールアドレス"
                placeholder="例）sample@tamaishiki.com"
              />
              <ProductField
                v-model="currentSchool.figuredProducts"
                :options="school.school.corporation.figuredProducts"
                :errorText="errorText"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import PostalCodeField from '@/components/forms/PostalCodeField.vue';
import ProductField from '@/components/forms/ProductField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';
import map from 'lodash/map';
import difference from 'lodash/difference';

export default {
  data() {
    return {
      errorText: '',
    };
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    TextField,
    PostalCodeField,
    ProductField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('school/fetchSchool', routeTo.params.id).then(() => {
        store.dispatch('video_viewing/fetchVideoViewings', routeTo.params.id).then(() => {
          next();
        });
      });
    } else {
      next();
    }
  },
  computed: {
    currentSchool() {
      if (this.school.editingSchool) {
        return this.school.editingSchool;
      } else {
        return this.school.school;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentSchool.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentSchool.brand);
    },
    ...mapState(['school']),
    ...mapState({
      videoViewings: (state) => state.video_viewing.videoViewings,
    }),
  },
  methods: {
    isRemovingProductUsedByVideo() {
      // 教場で利用教材が設定されている状態で、映像視聴IDの利用教材を外そうとした場合はエラーとする
      const schoolProducts = this.currentSchool.figuredProducts;
      const schoolProductCodes = map(schoolProducts, (product) => product.code);

      const videoProductCodes = map(this.videoViewings, (videoViewing) => videoViewing.product.code);
      const diffProductCodes = difference(videoProductCodes, schoolProductCodes);
      if (diffProductCodes.length > 0) return true;
      return false;
    },
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentSchool));
      if (this.isRemovingProductUsedByVideo()) {
        this.errorText =
          '映像視聴IDの利用教材と一致しないため、変更できません。映像視聴IDの利用教材を確認してください。';
        return;
      }
      this.startEditingSchool(this.currentSchool);
      this.$router.push({ name: 'school-id-confirm', params: { id: this.id } });
    },
    fillAddresses(addressComponents) {
      this.$logger.debug('addressComponents', addressComponents);
      this.currentSchool.state = addressComponents.city_state;
      this.currentSchool.address = addressComponents.address;
    },
    ...mapActions('school', ['startEditingSchool']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
